import { createAsyncThunk } from "@reduxjs/toolkit";
import { useGetData } from "../../../hooks/useGetData";
import { useUpdateData } from "../../../hooks/useUpdateData";
import { useInsertData } from "../../../hooks/useInsertData";
import { useDeleteData } from "../../../hooks/useDeleteData";
import notify from "../../../components/notify";



export const addToCart = createAsyncThunk(
  "/cartSlice/addToCart",
  async ({ data, rejectWithValue }) => {
    try {
      const response = await useInsertData(`v1/cart`, data);
      console.log("response", response);
      notify(response.message, "success");
      return response;
    } catch (error) {
      if (error.message == "Network Error") {
        notify("حدث خطأ اثناء الاتصال بالانترنت حاول مرة اخري ", "error");
        return rejectWithValue({ message:"حدث خطأ اثناء الاتصال بالانترنت حاول مرة اخري " });
      } else {
        notify(error.response.data.message, "error");
        return rejectWithValue(
          error.response?.data?.message || error?.response?.data
        );
      }
    }
  }
);

export const getCart = createAsyncThunk(
  "/cartSlice/getCart",
  async ({id}, { rejectWithValue }) => {
    try {

      const response = await useGetData(`v1/cart?userId=${id}`);
      console.log("response", response);
      notify(response.message, "success");
      return response;
    } catch (error) {
      if (error.message === "Network Error") {
        notify("حدث خطأ اثناء الاتصال بالانترنت حاول مرة اخري ", "error");
        return rejectWithValue({
          message: "حدث خطأ اثناء الاتصال بالانترنت حاول مرة اخري ",
        });
      } else {
        notify(error.response?.data?.message || "خطأ غير معروف", "error");
        return rejectWithValue(
          error.response?.data?.message || error?.response?.data
        );
      }
    }
  }
);
export const getCartCounter = createAsyncThunk(
  "/cartSlice/getCartCounter",
  async ({id}, { rejectWithValue }) => {
    try {

      const response = await useGetData(`v1/cart/getCartCounter?userId=${id}`);
      console.log("response", response);
      notify(response.message, "success");
      return response;
    } catch (error) {
      if (error.message === "Network Error") {
        notify("حدث خطأ اثناء الاتصال بالانترنت حاول مرة اخري ", "error");
        return rejectWithValue({
          message: "حدث خطأ اثناء الاتصال بالانترنت حاول مرة اخري ",
        });
      } else {
        notify(error.response?.data?.message || "خطأ غير معروف", "error");
        return rejectWithValue(
          error.response?.data?.message || error?.response?.data
        );
      }
    }
  }
);
export const getCartForFamily = createAsyncThunk(
  "/cartSlice/getCartForFamily",
  async ({id}, { rejectWithValue }) => {
    try {

      const response = await useGetData(`v1/cart/family/${id}`);
      console.log("response", response);
      notify(response.message, "success");
      return response;
    } catch (error) {
      if (error.message === "Network Error") {
        notify("حدث خطأ اثناء الاتصال بالانترنت حاول مرة اخري ", "error");
        return rejectWithValue({
          message: "حدث خطأ اثناء الاتصال بالانترنت حاول مرة اخري ",
        });
      } else {
        notify(error.response?.data?.message || "خطأ غير معروف", "error");
        return rejectWithValue(
          error.response?.data?.message || error?.response?.data
        );
      }
    }
  }
);
export const editCart = createAsyncThunk(
  "/cartSlice/editCart",
  async ({id,data}, { rejectWithValue }) => {
    try {

      const response = await useUpdateData(`v1/cart/update/${id}`,data);
      console.log("response", response);
      notify(response.message, "success");
      return response;
    } catch (error) {
      if (error.message === "Network Error") {
        notify("حدث خطأ اثناء الاتصال بالانترنت حاول مرة اخري ", "error");
        return rejectWithValue({
          message: "حدث خطأ اثناء الاتصال بالانترنت حاول مرة اخري ",
        });
      } else {
        notify(error.response?.data?.message || "خطأ غير معروف", "error");
        return rejectWithValue(
          error.response?.data?.message || error?.response?.data
        );
      }
    }
  }
);
export const deleteCart = createAsyncThunk(
  "/cartSlice/deleteCart",
  async ({id}, { rejectWithValue }) => {
    try {

      const response = await useDeleteData(`v1/cart/remove/${id}`);
      console.log("response", response);
      notify(response.message, "success");
      return response;
    } catch (error) {
      if (error.message === "Network Error") {
        notify("حدث خطأ اثناء الاتصال بالانترنت حاول مرة اخري ", "error");
        return rejectWithValue({
          message: "حدث خطأ اثناء الاتصال بالانترنت حاول مرة اخري ",
        });
      } else {
        notify(error.response?.data?.message || "خطأ غير معروف", "error");
        return rejectWithValue(
          error.response?.data?.message || error?.response?.data
        );
      }
    }
  }
);
